import React from 'react'

export const N_Button = () => {
    return(
        <button>
            BUTON
        </button>
    )
}